// TOP LEVEL IMPORTS
import gql from 'graphql-tag';

export default gql`
  fragment userFragment on User {
    _id
    __typename
    profile {
      firstName
      lastName
      infusionsoftId
      subscribed
      subscriptionPlan
    }
    emails {
      address
      verified
    }
    roles
    googleCalendarSet
  }
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/userFragment.js